import { ExtensionOption } from '../../extension-register/models/extension-option.interface';

export interface QueueMemberItemView extends ExtensionOption {
   queueMemberId: number;
   extensionQueueId: number;
}
export interface QueueMemberGroupItemView extends ExtensionOption {
   queueExtensionGroupId: number;
   queueExtensionId: number;
   extensionGroupId: number;
}
export const queueMemberKeyFields: string[] = ['queueMemberId', 'extensionQueueId', 'agentExtensionId'];
